export class SignalTag {
  constructor(
    public tagId: number,
    public tagName: string,
    public tagAlias: string,
    public tagDescription: string,
    public engUnits: string,
    public selected?: boolean) {
  }
}



// WEBPACK FOOTER //
// ./src/app/models/SignalTag.ts